import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';

import { ListGroup, ListGroupItem, ListGroupItemSubtitle, ListGroupItemTitle } from '@vds/lists';
import { Line } from '@vds/lines';
import { Body } from '@vds/typography';
import { TextLink } from '@vds/buttons';

import { VisuallyHiddenSpan } from './MainView/NBS.styles';

import { formatCurrency } from './NextBillsUtils';

const NBSModal = loadable(() => import('./NBSModal'));

const NBSLink = (props) => {
  const [showModal, setShowModal] = useState(false);
  const { monthlySurchargesText = '', dueMonthlyLabel = '', reviewNbs = '', isMovers = false, isVzForward = false } = props;

  return (
    <>
      {isVzForward ? (
        <TextLink
          data-testid="reviewNbsSummary"
          id="reviewNbsSummary"
          analyticstrack={reviewNbs}
          ariaLabel={reviewNbs}
          role="button"
          onClick={() => setShowModal(true)}
          data-track='{"type": "link",  "name": "review your next bill summary"}'
          onKeyDown={(e) => {
            if (e.keyCode === 13 || e.keyCode === 32 || e.keyCode === 27) {
              e.preventDefault();
            }
          }}
        >
          {reviewNbs}
        </TextLink>
      ) : isMovers ? (
        <Body size="large" color="#000000" bold={false}>
          {props?.billDisclaimer?.replace('$xx.xx', `${formatCurrency(props?.billCharges?.nextMonthGrandTotal)}`)}{' '}
          <TextLink
            id="BillDetails"
            ariaLabel="Monthly due view details"
            onClick={() => setShowModal(true)}
            onKeyDown={(e) => {
              if (e.keyCode === 13 || e.keyCode === 32) {
                e.preventDefault();
                setShowModal(true);
              }
            }}
            tabIndex="0"
            type="standAlone"
            role="link"
            data-track='{"type": "link",  "name": "Bill Details"}'
          >
            {props?.billLinkName}
          </TextLink>
        </Body>
      ) : (
        <>
          <Line type="secondary" />
          <ListGroup topLine={false} bottomLine={props?.pageName !== 'expresscheckout'} surface="light">
            <ListGroupItem
              actionElement="textLink"
              textLink={{
                role: 'button',
                id: 'estimated-next-bill',
                ariaLabel: 'Monthly due view details',
                text: 'Details',
                'data-track':
                  props?.pageName === 'expresscheckout' ? '{"type":"link","name":"Details|orderSummary","data":{"page":{"throttle":"nsa version|vhi|ec y"},"target":{"sandBox":"FWA_Express_T_Checkout"}}}' : '{"type":"link","name":"Details"}',
                'data-analyticstrack': 'nbsindex-test',
                'data-testid': 'nbsindex-test',
              }}
              disableContainerHitArea
              id={props?.pageName === 'expresscheckout' ? 'expressCheckoutNbs' : 'nbsindex-test'}
              onClick={(e) => {
                e.preventDefault();
                setShowModal(true);
              }}
            >
              <ListGroupItemTitle bold={false}>{dueMonthlyLabel}</ListGroupItemTitle>
              <ListGroupItemSubtitle>
                <VisuallyHiddenSpan>Disclamer</VisuallyHiddenSpan>
                <Body size="small" color="#6F7171" primitive="span">
                  {monthlySurchargesText}
                </Body>
              </ListGroupItemSubtitle>
            </ListGroupItem>
          </ListGroup>
        </>
      )}

      {showModal && (
        <NBSModal
          isOpen={showModal}
          change={() => {
            setShowModal(false);
          }}
        />
      )}
    </>
  );
};

const NbsLinkWrapper = (props) => {
  const [reducer, setReducer] = useState(false);
  useEffect(() => {
    setReducer(true);
  }, []);

  if (!reducer) return null;

  return <NBSLink {...props} />;
};

NBSLink.propTypes = {
  monthlySurchargesText: PropTypes.string,
  dueMonthlyLabel: PropTypes.string,
  reviewNbs: PropTypes.string,
  isMovers: PropTypes.bool,
  isVzForward: PropTypes.bool,
  billLinkName: PropTypes.string,
  billDisclaimer: PropTypes.string,
  billCharges: PropTypes.object,
  pageName: PropTypes.string,
};

export default React.memo(NbsLinkWrapper);
